module.exports = __webpack_public_path__ + "010e751d7ed2ed446b1c91e24e74789c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/more.png
// module id = 481
// module chunks = 0